










































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Utils } from "@/core/Utils";
import ProfileSection from "./profileSection.vue";

@Component({
  name: "profile-tab-container",
  components: { ProfileSection }
})
export default class ProfileTabContainer extends Vue {
  @Prop() public currentSection!: any;
  @Prop() public profileInfo!: any[];
  @Prop() public cleanSearchCriteria!: any;
  @Prop() public isSubTabContainer!: boolean;
  

  get isMobile() {
    return this.$store.state.isMobile;
  }
  onSetActiveChild(childInfo:any) {
    this.$emit("setActiveChild", childInfo);
  }
  goBack() {
      this.$emit("goBack");
  }
}
